import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-notepad-home",
  templateUrl: "./notepad-home.component.html",
  standalone: false,
})
export class NotepadHomeComponent {
  constructor(private router: Router) {}

  goToPullBatches() {
    this.router.navigate(["/notepad/pull-batches"]);
  }
}
